import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { LockClosedIcon, LockOpenIcon, ExclamationCircleIcon } from "@heroicons/react/solid";

import customerPortalLogo from "../../assets/logos/pppLogoShort.png";

function AuthSSOProcess(props) {
    const { authenticated, authenticationFailed, errorMessage } = props;

    const variants = {
        teal: {
            x: [-40, 40],
            y: [40, -40],
        },
        blue: {
            x: [40, -40],
            y: [-40, 40],
        },
        tan: {
            x: [0, 0],
            y: [0, 0],
        },
    };

    const transition = {
        x: {
            duration: 1,
            yoyo: Infinity,
            ease: "easeInOut",
        },
        y: {
            duration: 1,
            yoyo: Infinity,
            ease: "easeInOut",
        },
    };

    return (
        <div className={"flex flex-col gap-2 items-center justify-center h-screen -mt-24"}>
            <div className="flex items-center justify-center overflow-visible w-full h-48">
                <AnimatePresence>
                    <motion.svg
                        className={"overflow-visible"}
                        width={47}
                        height={41}
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <motion.rect
                            width={48}
                            height={48}
                            rx={64}
                            fill="#89EFD7"
                            variants={variants}
                            transition={transition}
                            animate="teal"
                        />
                        {authenticationFailed ? (
                            <ExclamationCircleIcon className="h-16 w-16 text-red-500" />
                        ) : authenticated ? (
                            <LockOpenIcon className="h-16 w-16 text-green-500" />
                        ) : (
                            <LockClosedIcon className="h-16 w-16 animate-pulse text-purple-500" />
                        )}
                        <motion.rect
                            width={48}
                            height={48}
                            rx={64}
                            fill="#2563F6"
                            variants={variants}
                            transition={transition}
                            animate="blue"
                        />
                    </motion.svg>
                </AnimatePresence>
            </div>
            <div className={"flex items-center justify-center text-slate-500 text-center"}>
                <div className={"max-w-lg"}>
                    {authenticationFailed ? (
                        <div className={"flex flex-col gap-4"}>
                            <p className={"font-medium text-slate-600"}>
                                Unfortunately we couldn't authenticate you with your SSO provider.
                            </p>
                            <p>
                                <a
                                    className={
                                        "text-secondary-600 font-medium hover:text-secondary-800 transition transition-colors cursor-pointer"
                                    }
                                    href={process.env.REACT_APP_RENEW_SESSION_REDIRECT_URL}
                                >
                                    <span>Please try logging in again,</span>
                                </a>
                                <span> or contact your organisation's techsupport if the issue persists.</span>
                            </p>
                            <div
                                className={
                                    "text-sm mx-auto rounded-md px-3 py-3 info bg-red-100 text-red-700 text-left"
                                }
                            >
                                <span className="font-medium">Error message: </span>
                                {errorMessage}
                            </div>
                        </div>
                    ) : authenticated ? (
                        <p className={"font-medium text-slate-500"}>
                            You have been authenticated successfully, you will be redirected soon...
                        </p>
                    ) : (
                        <p className={"font-medium text-slate-500"}>Authenticating you with your SSO provider..</p>
                    )}
                </div>
            </div>
            <div className={"fixed bottom-0 w-full"}>
                <div className={"w-full p-8 flex items-center justify-center"}>
                    <img alt="Customer Portal Logo" className="h-14" src={customerPortalLogo} />
                </div>
            </div>
        </div>
    );
}

export default AuthSSOProcess;
